import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const HtmlLang = () => {
  const { language } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = language === 'no' ? 'no' : 'en';
  }, [language]);

  return null;
};

export default HtmlLang;
